module.exports = __webpack_public_path__ + "dbfa4933ecfccb9ccfaa13ed393b94a5.png";